/** Removes dynamic params from current `location.pathname` and returns it
 * @example
 * `/active/123-321` -> `/active/{orderNr}`
 * `/start/active/123-321/test` -> `/start/active/{orderNr}/test`
 */
export function getPageName(pathname: string) {
  const orderPageRegexp = /(.+active\/+)(\d+-\d+)(.+)?/
  const internalOrderPageRegexp = /(.+orders\/+)(\d+-\d+)(.+)?/
  const preorderPageRegexp = /(.+preorder\/+)(\d+-\d+)(.+)?/
  const menuCategoryPageRegexp = /(.+menu\/+)([^/]+)(.*)/
  const placesPageRegexp = /(.+places\/+)(\d+)(.+)?/

  // removes multiple `/` and removes `/` from end
  const sanitized = pathname.replace(/\/+/g, '/').replace(/\/$/g, '')

  if (orderPageRegexp.test(sanitized)) {
    return sanitized.replace(orderPageRegexp, '$1{orderNr}$3')
  }

  if (internalOrderPageRegexp.test(sanitized)) {
    return sanitized.replace(internalOrderPageRegexp, '$1{orderNr}$3')
  }

  if (preorderPageRegexp.test(sanitized)) {
    return sanitized.replace(preorderPageRegexp, '$1{orderNr}$3')
  }

  if (menuCategoryPageRegexp.test(sanitized)) {
    return sanitized.replace(menuCategoryPageRegexp, '$1{categoryName}$3')
  }

  if (placesPageRegexp.test(sanitized)) {
    return sanitized.replace(placesPageRegexp, '$1{placeId}$3')
  }

  return sanitized
}
